import { Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, CancelarButton, Modal, Strong, Text, Title } from './styles';

export default function ModalFinalizarLote({
  showModalFinalizarLote,
  setShowModalFinalizarLote,
  finalizarLote,
}) {
  const closeModal = () => {
    setShowModalFinalizarLote(false);
  };

  const onOk = () => {
    finalizarLote();
    closeModal();
  };

  return (
    <>
      <Modal
        title="Finalizar lote"
        width={600}
        onCancel={closeModal}
        visible={showModalFinalizarLote}
        destroyOnClose={true}
        footer={[
          <CancelarButton key="cancel" onClick={closeModal}>
            Cancelar
          </CancelarButton>,

          <Button key="submit" onClick={onOk}>
            Sim, finalizar
          </Button>,
        ]}
      >
        <Row justify="center">
          <Title>Você deseja finalizar o Lote?</Title>
          <Text>
            Para finalizar o lote, ele não pode ter motorista &nbsp;
            <Strong>Na Fila</Strong>
            &nbsp; e nem &nbsp;
            <Strong>Em trânsito</Strong>, Deseja realmente finalizar o lote?
          </Text>
        </Row>
      </Modal>
    </>
  );
}

ModalFinalizarLote.propTypes = {
  showModalFinalizarLote: PropTypes.bool.isRequired,
  setShowModalFinalizarLote: PropTypes.func.isRequired,
  finalizarLote: PropTypes.func.isRequired,
};
